import React from 'react';

/**
 * ResponsiveContainer - Wrapper component for page content
 * Provides consistent responsive padding and prevents content overflow
 * 
 * Usage:
 * <AdminLayout>
 *   <ResponsiveContainer>
 *     ... your page content ...
 *   </ResponsiveContainer>
 * </AdminLayout>
 */
const ResponsiveContainer = ({ children, className = '' }) => {
  return (
    <div className={`w-full max-w-full overflow-x-hidden px-3 py-3 sm:px-4 sm:py-4 md:px-6 md:py-6 lg:px-8 lg:py-8 ${className}`}>
      {children}
    </div>
  );
};

export default ResponsiveContainer;
